import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  helpSupportData: [],
  totalhelpSupport: 0,
}

export const helpSupportSlice = createSlice({
  name: "helpSupport",
  initialState,
  reducers: {
    sethelpSupportData(state, { payload }) {
      state.helpSupportData = payload.result
      state.totalhelpSupport = payload.total
    },
    updateHelpSupportData(state, { payload }) {
      const objIndex = state.helpSupportData.findIndex((obj) => obj._id === payload._id);
      if(objIndex !== -1){
        state.helpSupportData[objIndex].status = payload.status
      }
    },
  }
})

export const { sethelpSupportData, updateHelpSupportData } = helpSupportSlice.actions;

export default helpSupportSlice.reducer;

export function gethelpSupport(limit, offset, keyword) {
  return async function gethelpSupportThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.gethelpSupport(limit, offset, keyword).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(sethelpSupportData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updateSupportStatus(id, status) {
  return async function updateSupportStatusThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updateSupportStatus(id, status).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(updateHelpSupportData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
